import { ZipCodeStoreProvider } from "@common/hooks";
import React from "react";
import { useOutlet } from 'react-router';

export const ZipCodeOutlet = () => {
    const outlet = useOutlet();
    return (
        <ZipCodeStoreProvider>
            {outlet}
        </ZipCodeStoreProvider>                    
    )
}   
